import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  NgZone,
  OnDestroy,
  OnInit,
  inject,
  output,
  contentChild,
} from '@angular/core';
import { fromEvent, Subject, Subscription } from 'rxjs';
import { filter, switchMapTo, take } from 'rxjs/operators';
import { ViewModeDirective } from '../directives/view-mode.directive';
import { EditModeDirective } from '../directives/edit-mode.directive';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'cue-editable',
  templateUrl: 'editable.component.html',
  styleUrls: ['editable.component.scss'],
  imports: [NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditableComponent implements OnInit, OnDestroy {
  private host = inject(ElementRef);
  private cdr = inject(ChangeDetectorRef);
  edit = output<boolean>();
  viewModeTpl = contentChild(ViewModeDirective);
  editModeTpl = contentChild(EditModeDirective);

  mode: 'view' | 'edit' = 'view';

  editMode = new Subject();
  editMode$ = this.editMode.asObservable();
  subs: Subscription[] = [];

  @HostBinding('class.edit-mode')
  get isEditMode() {
    return this.mode === 'edit';
  }

  @HostBinding('class.view-mode')
  get isViewMode() {
    return this.mode === 'view';
  }

  ngOnDestroy(): void {
    this.subs.forEach((x) => x.unsubscribe());
  }

  get currentView() {
    return this.mode === 'view' ? this.viewModeTpl().tpl : this.editModeTpl().tpl;
  }

  ngOnInit() {
    this.viewModeHandler();
    this.editModeHandler();
  }

  private viewModeHandler() {
    this.subs.push(
      fromEvent(this.element, 'click')
        .pipe()
        .subscribe((e: any) => {
          if (this.mode === 'edit') return;
          this.mode = 'edit';
          this.edit.emit(true);
          this.editMode.next(true);
          e.stopPropagation();

          this.cdr.detectChanges();
        })
    );
  }

  private editModeHandler() {
    const clickOutside$ = fromEvent(document, 'click').pipe(
      filter(({ target }) => {
        const popup: any = document.getElementsByClassName('editablePreventClose')[0];
        if (popup?.contains(target)) {
          return false;
        }
        return this.element.contains(target) === false;
      }),
      take(1)
    );

    this.subs.push(
      this.editMode$
        .pipe(
          switchMapTo(clickOutside$)
          //untilDestroyed(this)
        )
        .subscribe((event) => {
          if (this.mode === 'view') return;
          this.mode = 'view';
          this.cdr.detectChanges();
        })
    );
  }

  private get element() {
    return this.host.nativeElement;
  }
}
